/** Whether `element` is in the document and rendered. */
export function isRendered(element) {
    return !!element && element.isConnected && element.getClientRects().length > 0;
}

/** Focus `target`. An element that takes no focus gets tabindex="-1" until it loses focus. */
function tryFocus(target) {
    const focused = () => target.ownerDocument.activeElement === target;
    target.focus({ preventScroll: true });
    if (focused() || target.hasAttribute('tabindex')) {
        return focused();
    }
    target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
    if (!focused()) {
        target.removeAttribute('tabindex');
        return false;
    }
    target.addEventListener('blur', () => target.removeAttribute('tabindex'), { once: true });
    return true;
}

/**
 * Focus the first rendered element of `candidates` that takes focus, and
 * return it. Empty slots are skipped. The page does not scroll, so the reader
 * keeps their place.
 *
 * @param {...(HTMLElement|null|undefined)} candidates
 * @returns {HTMLElement|null}
 */
export function focusFirstRendered(...candidates) {
    return candidates.find((candidate) => isRendered(candidate) && tryFocus(candidate)) ?? null;
}
